import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';

import logo from '@/assets/logo.svg';

import localForage from '@/services/localforage.js';

import { useLoggingStore } from '@/store.js';

const useStyles = makeStyles((theme) => ({
    pageContainer: {
        backgroundColor: '#F9F8F4',
        color: '#2e2e2e',
        padding: '5rem',
        display: 'flex',
        flexDirection: 'column',
        gap: '3rem',

        [theme.breakpoints.down('xs')]: {
            padding: '4rem 2rem',
        },
    },
    logo: {
        width: '15rem',
    },
    largeText: {
        margin: 0,
    },
    smallText: {
        margin: 0,
        lineHeight: '24px',
    },
    button: {
        height: theme.buttonShape?.height ?? '2.625rem',
        backgroundColor: theme.palette.common?.yellow ?? '#ffc877',
        borderRadius: theme.buttonShape?.radius ?? '0.25rem',
        width: '15rem',
        '&:hover': {
            backgroundColor: theme.palette.common?.yellow ?? '#ffc877',
        },
    },
    actionContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: '1rem',
    },
    resetLink: {
        padding: 0,
        minWidth: 'auto',
        backgroundColor: 'transparent',
        color: '#666',
        fontSize: '0.875rem',
        textTransform: 'none',
        textDecoration: 'underline',
        '&:hover': {
            backgroundColor: 'transparent',
            color: '#2e2e2e',
        },
    },
}));

const ErrorFallback = () => {
    const { t } = useTranslation();
    const classes = useStyles();
    const largeText = useLoggingStore((state) => state.largeText);
    const smallText = useLoggingStore((state) => state.smallText);
    const ctaText = useLoggingStore((state) => state.ctaText);

    const handleClearData = async () => {
        try {
            await localForage.removeItem('prismic-storage');
        } catch (error) {
            console.error('Failed to clear data:', error);
        }
        window.location.reload();
    };

    return (
        <div className={classes.pageContainer}>
            <img className={classes.logo} src={logo} alt="Eterno Logo" />
            <h1 className={classes.largeText}>{largeText || t('ErrorFallbackHeading')}</h1>
            <p className={classes.smallText}>{smallText || t('ErrorFallbackParagraph')}</p>
            <div className={classes.actionContainer}>
                <Button onClick={() => window.location.reload()} className={classes.button} variant="contained">
                    {ctaText || t('ErrorFallbackCta')}
                </Button>
                <Button onClick={handleClearData} className={classes.resetLink} variant="text">
                    {t('ErrorFallbackResetApp')}
                </Button>
            </div>
        </div>
    );
};

export default ErrorFallback;
